import type { PropsElement } from '../props';
import type { Bounds, BuildStore, ToolFn, ToolSpec } from '../types';
import { audit, auditSpec } from './audit';
import { build, buildSpec } from './build';
import { check, checkSpec } from './check';
import { count, countSpec } from './count';
import { describe, describeSpec } from './describe';
import { exportSpec, exportTakeoff } from './export';
import { find, findSpec } from './find';
import { highlight, highlightSpec } from './highlight';
import { near, nearSpec } from './near';
import { properties, propertiesSpec } from './properties';
import { query, querySpec } from './query';
import { scene, sceneSpec } from './scene';
import { takeoff, takeoffSpec } from './takeoff';

export const TOOL_SPECS: ToolSpec[] = [
  describeSpec,
  countSpec,
  findSpec,
  querySpec,
  propertiesSpec,
  takeoffSpec,
  exportSpec,
  nearSpec,
  auditSpec,
  sceneSpec,
  highlightSpec,
  buildSpec,
  checkSpec,
];

export function makeTools(
  elements: PropsElement[],
  bounds?: Record<number, Bounds>,
  store?: BuildStore,
): Record<string, ToolFn> {
  return {
    describe_model: describe(elements),
    count_elements: count(elements),
    query_elements: query(elements),
    find_elements: find(elements),
    list_properties: properties(elements),
    quantity_takeoff: takeoff(elements),
    export_takeoff: exportTakeoff(elements),
    elements_near: near(elements, bounds),
    audit_model: audit(elements),
    scene: scene(elements, bounds),
    highlight: highlight(),
    build: build(store),
    check_building: check(store),
  };
}

export type { Attachment, Cell, GroupBy, TakeoffSheet } from './export';
export type { TakeoffResult } from './takeoff';
export { compare, fieldValue, type Op } from './fields';
export {
  materialClassIn,
  materialMatcher,
  MATERIAL_CLASSES,
  normalizeType,
  TYPE_ALIASES,
  typeIn,
  typeWords,
} from './vocabulary';
